import Button from 'components/button'
import Checkbox from 'components/checkbox'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TableFooter
} from 'components/uikit-adapter/index'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'

const ListPermissionsSettings = ({ profilePermissions, profileTypesAccess, accessProfile, onChanceCheckBox, save }) => (
  <Table
    fixedHeader
    multiSelectable={false}
    selectable={false}
    wrapperStyle={{ height: '100%' }}
    bodyStyle={{ height: 'calc(100% - 135px)', borderTop: '1px solid #E0E0E0', backgroundColor: 'var(--color-contrast-white)' }}
  >
    <TableHeader
      displaySelectAll={false}
      adjustForCheckbox={false}
      style={{ borderBottom: 'none' }}
    >
      <TableRow style={{ borderBottom: 'none' }}>
        <TableHeaderColumn style={{ width: '100%' }}>{intl.get('master-data.permissions-settings.table.permissions')}</TableHeaderColumn>
        {profileTypesAccess.map(profileTypeAccess => (
          <TableHeaderColumn style={{ width: '100%' }}>{profileTypeAccess.Description}</TableHeaderColumn>
        ))}
      </TableRow>
    </TableHeader>
    <TableBody
      displayRowCheckbox={false}
      showRowHover
    >
      {profilePermissions.map((profilePermission) => (
        <TableRow key={profilePermission.Id}>
          <TableRowColumn style={{ width: '100%' }}>
            {profilePermission.Description}
          </TableRowColumn>
          {profileTypesAccess.map((profileTypeAccess) => (
            <TableRowColumn style={{ width: '100%' }} key={profileTypeAccess.Id}>
              <Checkbox
                name={`checkbox-${profileTypeAccess.Id}-${profilePermission.Id}`}
                checked={accessProfile.find(x => x.TipoPerfilAcesso === profileTypeAccess.Id && x.ProfilePermissions.includes(profilePermission.Id))}
                onChange={() => onChanceCheckBox(profilePermission.Id, profileTypeAccess.Id)}
                data-testid={`checkbox-${profileTypeAccess.Id}-${profilePermission.Id}`}
              />
            </TableRowColumn>
          ))}
        </TableRow>
      ))}
    </TableBody>
    <TableFooter
      data-testid='table-footer'
      style={{
        borderTop: 'solid',
        borderColor: 'var(--color-neutral-300)',
        borderWidth: '1px'
      }}
    >
      <Button
        buttonType="primary"
        value={intl.get('geral.buttonsDefault.save')}
        onClick={save}
        className="button"
        style={{ textAlign: 'center', verticalAlign: 'center' }}
      />
    </TableFooter>
  </Table >
)

ListPermissionsSettings.propTypes = {
  accessProfile: PropTypes.shape({
    find: PropTypes.func
  }).isRequired,
  onChanceCheckBox: PropTypes.func.isRequired,
  profilePermissions: PropTypes.array.isRequired,
  profileTypesAccess: PropTypes.shape({
    map: PropTypes.func
  }).isRequired,
  save: PropTypes.any.isRequired
}

export default ListPermissionsSettings;
